import React from 'react';
import TriggerRuleInfoComponent from 'components/triggers/TriggerRuleInfoComponent';
import EditIcon from 'components/pure/utils/icon/EditIcon';
import {Link} from 'react-router';
import TriggerRuleStore from 'stores/triggers/TriggerRuleStore';

export default class TriggerRuleInfoContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSharing: false,
    };
  }

  componentDidMount() {
    const triggerState = TriggerRuleStore.getState();
    if (triggerState.stagedPermissions) {
      this.setState({showSharing: true});
    }
  }

  render() {
    const {rule, readonly} = this.props;

    const canEditAndNotReadonlyPage = rule.rulePermissions.EDIT !== undefined && !readonly;

    return (
      <div className="trigger-rule-container trigger-container">
        <header>
          <div className="info">
            <div className="title">Trigger</div>
            <div className="description">What event is being tracked</div>
          </div>
          <div className="action-buttons">
            {canEditAndNotReadonlyPage && (
              <div className="trigger-edit-icon">
                <Link to={`/admin/actions/${this.props.rule.id}/edit`}>
                  <EditIcon />
                </Link>
              </div>
            )}
          </div>
        </header>
        <div className="trigger-rule-content trigger-content">
          <TriggerRuleInfoComponent {...this.props} />
        </div>
      </div>
    );
  }
}
